"use client";

export default function ScopeSection() {
  return (
    <section className="bg-white py-10 px-4 md:px-6">
      <div className="max-w-[880px] mx-auto">
        <div className="bg-cream rounded-xl border-l-4 border-primary p-6">
          <h3 className="text-lg font-bold text-secondary mb-2">Honest Scope</h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            We perform maintenance and cleaning on existing windows. We do not install new windows or perform structural repairs. For major issues found during inspection, we refer you to licensed Florida contractors at no cost.
          </p>
        </div>
      </div>
    </section>
  );
}